AgrimarketControllers.controller('quoteController', ['$scope', '$rootScope', '$routeParams', '$http', '$filter', '$location', '$log', '$interval', 'currentUserFactory', 'configurationFactory',
     'parametersFactory', 'enumFactory', 'quoteService', 'colonnesQuote', 'colonnesQuoteWithoutRealTime',
    function ($scope, $rootScope, $routeParams, $http, $filter, $location, $log, $interval, currentUserFactory, configurationFactory, parametersFactory, enumFactory, quoteService, colonnesQuote, colonnesQuoteWithoutRealTime) {
        if (!$rootScope.ModuleCotation.Active && !$rootScope.ModuleHashtagri.Active)
            $location.path("/");

        
    }]);
